import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'suffixMinMax'})
export class SuffixMinMaxPipe implements PipeTransform {
  transform(value: string): string {
    return value.split('_').pop();
  }
}